import { DS_COMMON_NAMESPACE } from '@frontends/ds';
import { UI_KIT_NAMESPACE } from '@frontends/ui-kit';
import { initI18n } from '@frontends/util-i18n';
import { getEntityConfig } from './hooks/useEntityConfig';

const i18n = initI18n({
  namespaces: ['common', DS_COMMON_NAMESPACE, UI_KIT_NAMESPACE],
  defaultNS: 'common',
  loadPath: '/locales/{{lng}}/{{ns}}.json',
  offeredLanguages: getEntityConfig().VITE_CLIENT_PORTAL_SUPPORTED_LOCALES,
});

export default i18n;
